
export interface AccountsState {
  accounts:AccountItem[],
  accountItem?:AccountItem,
  protocolList:any[]
}

export interface AccountItem {
  id?:number,
  login:string,
  password?:string,
  confirm_password?:string,
  partner:string,
  partner_id?:number,
  protocol:string,
  protocol_id?:number,
  transport:string,
  transport_id?:number|null,
  status:number,
  push_statuses?:number,
  status_report?:number,
  url?:string|null,
  max_throughput?:string,
  immediate_response_needed?:number,
}

export interface AccountFilter {
  login?:number,
  protocol?: string,
  partner?: string,
  transport?: string,
  status?: number,
}

export class AccountItemImpl implements AccountItem {
  login: string;
  partner: string;
  protocol: string;
  status: number;
  transport: string;
  push_statuses?:number;
  status_report?:number;
  max_throughput?:string;
  immediate_response_needed?:number;

  constructor() {
    this.login = '';
    this.partner = '';
    this.protocol = '';
    this.status = 0;
    this.transport = '';
    this.push_statuses = 0;
    this.status_report = 0;
    this.max_throughput = '10/1000'
    this.immediate_response_needed = 1;
  }
}